

function initMap() {

  const mapElement = document.getElementById('SpaceMap');

  if (!mapElement) {
    return;
  }

  const map = new google.maps.Map(document.getElementById('SpaceMap'), {
    center: {lat: 51.737, lng: 19.424},
    zoom: 15,
    mapId: '2ec0b0555391c807',
    keyboardShortcuts: false,
  });



  // Dodaj marker z własną ikoną
  const marker = new google.maps.Marker({
    position: {lat: 51.737, lng: 19.423},
    map: map,
    icon: {
      url: `${document.location.origin}/wp-content/themes/starter/dist/images/icons/ui/pin-noshadow.svg`,
      scaledSize: new google.maps.Size(56, 56),
    }
  });
}

// Funkcja do ładowania API Google Maps
function loadGoogleMapsAPI() {
  const script = document.createElement('script');
  script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCQIENOyE9zjSdjDgVvlkNpKMgj-zxs5ls&callback=initMap";
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
}

// Wywołaj funkcję ładującą API, kiedy DOM będzie gotowy
document.addEventListener('DOMContentLoaded', (event) => {
  window.initMap = initMap; // Ustaw funkcję globalnie
  loadGoogleMapsAPI(); // Załaduj Google Maps API
});
